export enum ETimerId {
    TABATA = 'tabata',
    AMRAP = 'amrap',
    EMOM = 'emom',
    FOR_TIME = 'for-time'
}